import { notNullOrUndefinedOrBlank } from "@/utility/functions";

export function dashable(value: any): string {
  return isReplaceableWithDefaultText(value) ? "-" : value.toString();
}

export function nullable(value: any): string {
  console.log(value);
  return isReplaceableWithDefaultText(value) ? "Brak danych" : value.toString();
}

function isReplaceableWithDefaultText(value: any): boolean {
  const result: boolean =
    !notNullOrUndefinedOrBlank(value) || value === "undefined" || value === "null";
  return result;
}
